// extracted by mini-css-extract-plugin
module.exports = {"modalForm":"ModalForm_modalForm__WruO7","row":"ModalForm_row__3vf4a"};